module.exports = __webpack_public_path__ + "img/top_dh@2x.096aa514.png";